import type { ProfileSettings } from '@/types'

/**
 * Default profile settings for new users
 */
export const DEFAULT_PROFILE_SETTINGS: ProfileSettings = {
  theme: 'modern',
  colorScheme: 'blue',
  visibility: {
    showPhoto: true,
    showContact: true,
    showExperience: true,
    showEducation: true,
    showSkills: true,
    showLanguages: true,
    showProjects: true,
    showDocuments: true,
  },
  customization: {
    headerStyle: 'centered',
    showScrollNav: true,
    animationsEnabled: true,
  },
}

/**
 * Get default or existing profile settings
 */
export function getProfileSettings(
  settings?: ProfileSettings
): ProfileSettings {
  if (!settings) {
    return DEFAULT_PROFILE_SETTINGS
  }

  // Merge with defaults to ensure all fields exist
  return {
    theme: settings.theme || DEFAULT_PROFILE_SETTINGS.theme,
    colorScheme: settings.colorScheme || DEFAULT_PROFILE_SETTINGS.colorScheme,
    visibility: {
      ...DEFAULT_PROFILE_SETTINGS.visibility,
      ...settings.visibility,
    },
    customization: {
      ...DEFAULT_PROFILE_SETTINGS.customization,
      ...settings.customization,
    },
  }
}
